var map = {
	"./actions": 2456,
	"./actions.json": 2456,
	"./components": 2457,
	"./components.json": 2457,
	"./directory": 2458,
	"./directory.json": 2458,
	"./eCircular": 2459,
	"./eCircular.json": 2459,
	"./errors": 2460,
	"./errors.json": 2460,
	"./hints": 2461,
	"./hints.json": 2461,
	"./project": 2462,
	"./project.json": 2462,
	"./regionalWorkPermitLabels": 2463,
	"./regionalWorkPermitLabels.json": 2463,
	"./settings": 2464,
	"./settings.json": 2464,
	"./table": 2465,
	"./table.json": 2465,
	"./tenancy": 2466,
	"./tenancy.json": 2466,
	"./tenantProject": 2467,
	"./tenantProject.json": 2467,
	"./tenders": 2468,
	"./tenders.json": 2468,
	"./userGuideForms": 2469,
	"./userGuideForms.json": 2469,
	"./workPermit": 2470,
	"./workPermit.json": 2470,
	"./zh-cn": 2471,
	"./zh-cn.json": 2471
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3187;